export const mapThemesArray = [
  {
    imgurl: "/images/map_1.png",
    title: "Spor i landskabet",
    attributionLink: "https://spor.dk/",
    attributionLinkText: "Spor",
    attribution: "Septima, © SDFI, © OpenStreetMap contributors",
  },
  {
    imgurl: "/images/map_2.png",
    title: "Skattekort",
    attributionLink: "https://byjagt.septima.dk/#/",
    attributionLinkText: "Byjagt",
    attribution: "Septima, © Maptiler, © OpenStreetMap contributors",
  },
  {
    imgurl: "/images/map_3.png",
    title: "RIDA vejtyper",
    attributionLink: "https://septima.dk/rida-web/",
    attributionLinkText: "RIDA",
    attribution: "Septima, © SDFI, © GeoDanmark",
  },
  {
    imgurl: "/images/map_4.png",
    title: "Septima Dark",
    attributionLink: "https://www.septima.dk/",
    attributionLinkText: "Septima Vector Tiles",
    attribution: "© SDFI, © OpenStreetMap contributors",
  },
  {
    imgurl: "/images/map_5.png",
    title: "OpenStreetMap Standard",
    attributionLink: "https://www.openstreetmap.org/",
    attributionLinkText: "OpenStreetMap",
    attribution: "© OpenStreetMap contributors",
  },
  {
    imgurl: "/images/map_6.png",
    title: "Septima Light",
    attributionLink: "https://www.septima.dk/",
    attributionLinkText: "Septima Vector Tiles",
    attribution: "© SDFI, © OpenStreetMap contributors",
  },
  {
    imgurl: "/images/map_7.png",
    title: "Orkanens øje",
    attributionLink:
      "https://cds.climate.copernicus.eu/cdsapp#!/dataset/reanalysis-era5-single-levels",
    attributionLinkText: "Copernicus Climate Data Store",
    attribution: "Septima, Copernicus",
  },
  {
    imgurl: "/images/map_8.png",
    title: "Septima Streets",
    attributionLink: "https://www.septima.dk/",
    attributionLinkText: "Septima Vector Tiles",
    attribution: "© SDFI, © OpenStreetMap contributors",
  },
  {
    imgurl: "/images/map_9.png",
    title: "Stormfulde Højder",
    attributionLink: "",
    attributionLinkText: "Højdekurver",
    attribution: "Septima, © Mapbox, © OpenStreetMap",
  },
  {
    imgurl: "/images/map_10.png",
    title: "Points of Interest",
    attributionLink: "https://www.boligsiden.dk/tilsalg/kort",
    attributionLinkText: "Boligsiden",
    attribution: "Septima, © SDFI, © OpenStreetMap contributors",
  },
  {
    imgurl: "/images/map_11.png",
    title: "Septima Outdoor",
    attributionLink: "https://www.septima.dk/",
    attributionLinkText: "Septima",
    attribution: "© SDFI, © OpenStreetMap contributors",
  },
  {
    imgurl: "/images/map_12.png",
    title: "CPH Flight",
    attributionLink: "https://www.septima.dk/",
    attributionLinkText: "Septima",
    attribution: "© OpenStreetMap",
  },
];
